import { render, staticRenderFns } from "./ls-change-component2.vue?vue&type=template&id=e51c66d6&scoped=true"
import script from "./ls-change-component2.vue?vue&type=script&lang=js"
export * from "./ls-change-component2.vue?vue&type=script&lang=js"
import style0 from "./ls-change-component2.vue?vue&type=style&index=0&id=e51c66d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51c66d6",
  null
  
)

export default component.exports